<template>
  <el-dialog title="修改密码" :visible.sync="ChangePswVisible" width="30%" :close-on-click-modal="false"
             :modal-append-to-body='false'>
    <el-form :model="dataForm" label-width="100px" ref="dataForm" :size="size" :rules="dataFormRules"
             label-position="right">
      <el-form-item label="原密码" prop="oldPass">
        <el-input v-model="dataForm.oldPass" auto-complete="off" show-password clearable></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPass">
        <el-input v-model="dataForm.newPass" auto-complete="off" show-password clearable></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPass">
        <el-input v-model="dataForm.confirmPass" auto-complete="off" show-password clearable></el-input>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click.native="submitForm" :loading="editLoading">确 定</el-button>
    <el-button @click="callOf('dataForm')">取 消</el-button>
  </el-dialog>
</template>

<script>
  import axios from 'axios';
  export default {
    data() {
      return {
        size: 'small',
        editLoading: false,
        ChangePswVisible: false,
        dataFormRules: {
          oldPass: [{required: true, message: '请输入原密码', trigger: 'blur'}],
          newPass: [{required: true, message: '请输入新密码', trigger: 'blur'}],
          confirmPass: [{required: true, message: '请输入确认密码', trigger: 'blur'}]
        },
        dataForm: {}
      }
    },
    methods: {
      // 设置可见性
      setChangePswVisible: function (ChangePswVisible) {
        this.ChangePswVisible = ChangePswVisible
      },

      // 修改操作
      submitForm: function () {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            this.editLoading = true
            let params = Object.assign({}, this.dataForm)
            this.$api.personCenter.save(params).then((res) => {
              this.editLoading = false
              if (res.code === 200) {
                this.$message({message: '修改成功', type: 'success'})
                this.ChangePswVisible = false
                this.$refs['dataForm'].resetFields()
//                this.$api.login.logout().then((res) => {
//                }).catch(function (res) {
//                })
              } else {
                this.$message({message: '操作失败, ' + res.msg, type: 'error'})
              }
            })
          }
        })
      },

      callOf(formName){
        this.ChangePswVisible = false;
        this.$refs[formName].resetFields();
      }
    },
    mounted() {

    }
  }
</script>




// WEBPACK FOOTER //
// src/views/Sys/ChangePsw.vue